import { PAYMENT_TYPE } from "./utils";
import CIcon from "@coreui/icons-react";
import { PaymentMethodSourceLabel } from "./components/PaymentMethodSourceLabel";
import {
  formatPaymentMethodExpiration,
} from "./utils";

type PaymentMethodRow = {
  id: string;
  default?: boolean;
  type: string;
  providerName: string;
  last4: string;
  expiryDate?: string | null;
  status?: string;
};

export const getPaymentMethodColumns = (
  isAutopayEnabled?: boolean,
  autopayPaymentMethodId?: string | null
) => [
  {
    key: "type",
    title: "",
    className: "payment-method-type-column",
    render: (type: string, data: PaymentMethodRow) => {
      if (type === "CREDIT_CARD") {
        let cardType = Object.values(PAYMENT_TYPE).filter(
          (paymentType) =>
            type === "CREDIT_CARD" &&
            paymentType.KEY ===
              data.providerName.toUpperCase().replace(" ", "_")
        )?.[0];
        if (cardType == null) cardType = PAYMENT_TYPE.CARD;

        return (
          <span className="payment-method-type-cell">
            <img
              src={cardType.LOGO}
              alt={cardType.KEY}
              className="payment-method-type-icon"
            />
          </span>
        );
      }

      const bank = Object.values(PAYMENT_TYPE).filter(
        (paymentType) => paymentType.KEY === type
      )?.[0];
      if (bank == null) return null;
      return (
        <span className="payment-method-type-cell">
          <CIcon
            name={bank.LOGO}
            alt={bank.KEY}
            size="lg"
            className="payment-method-type-icon payment-method-type-icon--bank"
          />
        </span>
      );
    },
  },
  {
    key: "display",
    title: "Payment Source",
    render: (_display: string, data: PaymentMethodRow) => {
      const showAutopayBadge =
        Boolean(isAutopayEnabled) &&
        Boolean(autopayPaymentMethodId) &&
        data.id === autopayPaymentMethodId;

      return (
        <PaymentMethodSourceLabel
          paymentMethod={data}
          showAutopayBadge={showAutopayBadge}
          showExpiry={false}
        />
      );
    },
  },
  {
    key: "expiryDate",
    title: "Expiration",
    render: (_expiryDate: string | undefined, data: PaymentMethodRow) =>
      formatPaymentMethodExpiration(data),
  },
];

/** @deprecated Use getPaymentMethodColumns for autopay-aware rendering */
export const COLUMNS = getPaymentMethodColumns();
